export default class NotificationsListCtrl {
  constructor ($scope,uiGridConstants, $interval, GeneralSettingsSrv, i18nService, $mdDialog, $cookies, Validations, permissions, GlobalConfig) {
    var notificationListVM = this
    const user = JSON.parse($cookies.get('currentUser'))
    const currentRoleId = JSON.parse($cookies.get('hasRoleId'))
    const startMessageId = GlobalConfig.generalSettings.notificationsType.startMessage

    $scope.$on('permissionsChanged', filterGridData)

    i18nService.setCurrentLang('es')

    notificationListVM.filter = filter
    notificationListVM.singleFilter = singleFilter
    notificationListVM.disableNotification = disableNotification
    notificationListVM.isAdminOrGerencialConsultant = Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)

    notificationListVM.gridNotifications = {
      enableFiltering: true,
      columnDefs : [
        {
         name: 'Nombre',
         displayName: 'Nombre',
         field: 'notification_name',
         width: '15%',
         headerCellClass: notificationListVM.highlightFilteredHeader,
         enableGridMenu: false,
         enableHiding : false,
         enablePinning: false,
         enableColumnMenu: false,
         enableSorting: false,
         cellClass: 'text-xs',
         headerCellClass: 'font-normal text-xs'
        },
        {
          name: 'Tipo notificación',
          displayName: 'Tipo notificación',
          field: 'notification_type',
          width: '15%',
          enableGridMenu: false,
          enableHiding : false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        },
        {
          name: 'Fecha de envío',
          displayName: 'Fecha de envío',
          field: 'delivery_date',
          width: '15%',
          enableGridMenu: false,
          enableHiding : false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs',
          cellFilter: "date: 'dd/MM/yyyy': 'UTC'"
        },
        {
          name: 'Tipo de envío',
          displayName: 'Tipo de envío',
          field: 'delivery_type',
          width: '15%',
          enableGridMenu: false,
          enableHiding : false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        },
        {
          name: 'Roles de envío',
          displayName: 'Roles de envío',
          field: 'role_name',
          width: '15%',
          enableGridMenu: false,
          enableHiding : false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs',
          cellTemplate:'<div class="ui-grid-cell-contents">'+
                        '<a href="#" data-toggle="tooltip" data-placement="bottom" title="{{row.entity.role_name}}">{{row.entity.role_name}}</a>' +
                        '</div>',
        },
        {
          name: 'Acciones',
          displayName: 'Acciones',
          field: '',
          width: '25%',
          enableFiltering: false,
          enableGridMenu: false,
          enableHiding : false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'column-center text-xs',
          headerCellClass: 'column-center font-normal text-xs',
          cellTemplate: require('./cellActionsNotificationsList.html')
        },
      ],
      onRegisterApi: function(gridApi){
        notificationListVM.gridApi = gridApi;
        notificationListVM.gridApi.grid.registerRowsProcessor( notificationListVM.singleFilter, 200 );
        $interval( function() {
           notificationListVM.gridApi.core.handleWindowResize();
         }, 500, 10);
      },
    }

    activate()

    function activate() {
      return getNotifications().then( () => {} )
    }

    function getNotifications(){
      let header = { }

      if (notificationListVM.isAdminOrGerencialConsultant) {
        header.userId = user.id
        header.rolId  = currentRoleId
      }

      return GeneralSettingsSrv.notification.getList(header)
      .$promise.then(function (dataReturn) {
        if(dataReturn.status == true){
          notificationListVM.gridData = dataReturn.data
          filterGridData()
        } else {
          notificationListVM.gridNotifications.data = []
        }
      },function(data) {
       console.log(data)
      })
    }

    function filter(){
      notificationListVM.gridApi.grid.refresh();
    };

    function singleFilter(renderableRows){
      var matcher = new RegExp(notificationListVM.searchFilter, 'i');
      renderableRows.forEach( function( row ) {
        var match = false;
        [ 'notification_type', 'stage_name', 'delivery_type', 'role_name' ].forEach(function( field ){
          if ( row.entity[field] && row.entity[field].match(matcher) ){
            match = true;
          }
        });
        if ( !match ){
          row.visible = false;
        }
      });
      return renderableRows;
    };

    function disableNotification (row){
      let notificationName = row.entity.notification_name
      let notificationType = row.entity.notification_type
      let notificationId = row.entity.notification_id
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
          $scope.notificationName = notificationName
          $scope.notificationType = notificationType
          $scope.notificationId = notificationId
          $scope.close = function() {
            $mdDialog.hide()
          }

          $scope.disable = function(notificationId){
            GeneralSettingsSrv.disableNotification.disable({idNotification:notificationId})
            .$promise.then(function (dataReturn) {
              if(dataReturn.status == true){
                var index = notificationListVM.gridNotifications.data.indexOf(row.entity);
                notificationListVM.gridNotifications.data.splice(index, 1);
                notificationListVM.gridApi.grid.refresh()
                $mdDialog.hide()
              } else {

              }
            },function(data) {
             console.log(data)
            })
          }
        }],
        template: require('./confirmDisableNotificationModal.html'),
        clickOutsideToClose:true
      })
    }

    function filterGridData () {
      if (notificationListVM.gridData) {
        if (permissions.hasPermission('mensajes-de-inicio-edit')) {
          notificationListVM.gridNotifications.data = angular.copy(notificationListVM.gridData)
        } else {
          notificationListVM.gridNotifications.data = notificationListVM.gridData.filter((notification) => {
            return notification.notification_type_id !== startMessageId
          })
        }
      }
    }
  }
}

NotificationsListCtrl.$inject = ['$scope','uiGridConstants', '$interval', 'GeneralSettingsSrv', 'i18nService','$mdDialog', '$cookies', 'Validations', 'permissions', 'GlobalConfig'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/notifications/list/notificationsListCtrl.js